export const getPaidColor = (value) => {
  switch (true) {
    case value >= 1: return 'rgb(65, 141, 88)';
    case value >= 0.8 && value < 1: return '#e6e600';
    case value >= 0.5 && value < 0.8: return '#B48818';
    case value < 0.5: return 'rgb(239, 65, 48)';
    default: return 'rgb(29, 31, 46)';
  }
};